import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const appConfigurationContext = /*#__PURE__*/React.createContext(undefined);
function AppConfigurationContainerBase(_ref) {
  let {
    children,
    data
  } = _ref;
  const memoizedData = React.useMemo(() => data, [data]);
  return /*#__PURE__*/_jsx(appConfigurationContext.Provider, {
    value: memoizedData,
    children: children
  });
}
function useAppConfiguration() {
  const ctx = React.useContext(appConfigurationContext);
  if (!ctx) {
    throw new Error('useAppConfiguration must be used within a AppConfigurationContainer');
  }
  return ctx;
}
const AppConfigurationContainer = /*#__PURE__*/React.memo(AppConfigurationContainerBase);
export { appConfigurationContext as AppConfigurationContext, AppConfigurationContainer, useAppConfiguration };